import React, { useEffect, useMemo, useState } from "react"
import styled from "styled-components"
import EvaluationHost from "./EvaluationHost"
import Modal from "./Modal"
import { ACTIVE_HEADER_VARIANT, HEADER_VARIANTS } from "../config/headerTheme"

const resolveGooglePlaceId = (almacenInfo) =>
    almacenInfo?.place_id ||
    almacenInfo?.placeId ||
    almacenInfo?.resto?.place_id ||
    almacenInfo?.resto?.placeId ||
    almacenInfo?.restaurant?.place_id ||
    almacenInfo?.restaurant?.placeId ||
    almacenInfo?.restoInfo?.place_id ||
    almacenInfo?.restoInfo?.placeId ||
    ""

const ThankYouPage = ({
    noVoting = false,
    onSelection,
    onNoVoting,
    onThanksPage,
    congrats,
    almacenInfo,
    customQuestions=[],
}) => {
    const [showGoogleReviewModal, setShowGoogleReviewModal] = useState(false)
    const googlePlaceId = useMemo(() => resolveGooglePlaceId(almacenInfo), [almacenInfo])
    const googleReviewUrl = useMemo(() => {
        if (!googlePlaceId) return ""
        return `https://search.google.com/local/writereview?placeid=${encodeURIComponent(googlePlaceId)}`
    }, [googlePlaceId])

    const openGoogleReview = () => {
        if (!googleReviewUrl) return
        window.open(googleReviewUrl, "_blank", "noopener,noreferrer")
        setShowGoogleReviewModal(false)
    }

    if (noVoting) {
        return (
            <Wrapper>
                <Inner>
                    {congrats ? (
                        <ThankYouContainer>
                            <Title>¡Gracias por tu valoración!</Title>
                            <Subtitle>Hemos recibido tus respuestas</Subtitle>
                            <Spacer />
                            <Paragraph>
                                Tu opinión nos ayuda a mejorar la experiencia en tu próxima
                                visita.
                            </Paragraph>
                        </ThankYouContainer>
                    ) : (
                        <ThankYouContainer>
                            <Title>¡Gracias por tu valoración!</Title>
                            <Paragraph>¡Esperamos tu calificación en tu próxima visita!</Paragraph>
                        </ThankYouContainer>
                    )}
                    {congrats && !!googleReviewUrl && (
                        <GoogleReviewWrap>
                            <GoogleReviewButton type="button" onClick={openGoogleReview}>
                                Evalúanos también en Google
                            </GoogleReviewButton>
                        </GoogleReviewWrap>
                    )}
                </Inner>

            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <Inner>
                <ThankYouContainer>
                    <Title>¡Gracias por tu like!</Title>
                    <Heading>Responde estas preguntas.</Heading>
                    <Paragraph>Tu opinión nos ayuda a mejorar.</Paragraph>
                </ThankYouContainer>

                <EvaluationHost
                    onSelection={onSelection}
                    onNoVoting={onNoVoting}
                    onThanksPage={onThanksPage}
                    customQuestions={customQuestions}
                />
            </Inner>
        </Wrapper>
    )
}

export default ThankYouPage

/* ========== styled-components ========== */

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const Inner = styled.div`
  width: 100%;
  max-width: 720px;
`

const ThankYouContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 0 20px;
  gap: 8px;
`

const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`

const Subtitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`

const Paragraph = styled.p`
  margin: 0;
  font-size: 14px;
  color: #374151;
`

const Spacer = styled.div`
  height: 12px;
`

const GoogleReviewWrap = styled.div`
  padding: 0 15px 24px;
  display: flex;
  justify-content: center;
`

const GoogleReviewButton = styled.button`
  height: 46px;
  width: 100%;
  max-width: 320px;
  padding: 0 18px;
  border: none;
  border-radius: 999px;
  background: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;

  &:hover {
    background: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].primary};
  }

  &:active {
    transform: scale(0.98);
  }
`

const ModalText = styled.p`
  margin: 0;
  text-align: center;
  color: #374151;
  line-height: 1.5;
`

const GoogleReviewModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 4px 8px 30px;
`

const ModalIllustration = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: 120px;
    height: auto;
  }
`

const Heading = styled.h6`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #111827;
`
